import React, { useState, useEffect, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { Typography, Box } from '@material-ui/core';
import useStyles from './addonsStyles';
import { getAddOns } from './manageAddons.util';
import ActiveAddonsCard from './ActiveAddonsCard';
import { useWindowDimension } from '../../../hooks/windowDimensions';
import { PlusIcon } from '../../../sharedcomponents/inputs/svg-icons/CustomSvgIcons';
import { getEligibilityForManageAddons, getActiveAddons } from './manageAddons.api';
import { getCurrentlyActiveAddons } from './manageAddons.util';
import { useApolloClient } from '@apollo/client';
import { getMyPlanDetails } from '../my-services/myServices.util';
import Loading from '../../../components/loading/Loading';
import { RedesignContext } from '../../../global-context-redesign';
import theme from '../../../theme/MyEirTheme';
import { subscribe } from 'pubsub-js';
import { clearCacheQuery } from '../../../utils/cache';
import EirButton from '../../../theme/EirButton';
import addOnIcon from '../images/addOn.png';
import ServicesIcon from '../my-services/ServicesIcon';
const ActiveAddonsContainer = () => {
    const value = useContext(RedesignContext);
    const classes = useStyles();
    const [width, height] = useWindowDimension();
    const graphql = useApolloClient();
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showAddons, setShowAddons] = useState(value?.state?.myAddons?.showAddons);
    const [collectionStatus, setCollectionStatus] = useState(true);
    const [accountStatus, setAccountStatus] = useState('');
    const [fetchAddons, setFetchAddons] = useState(true);
    const [displayAddOns, setDisplayAddOns] = useState(false);
    const [uniqueShowArr, setUniqueShowArr] = useState([]);
    const numCards = showAddons?.length;
    // const gridMdProp = numCards === 1 ? 12 : numCards === 2 ? 6 : 4;
    const gridMdProp = 4;
    const gridMdProp1 = numCards === 1 ? 12 : 6;

    const sessionValue = JSON.parse(sessionStorage.getItem('LoggedinServices'));

    const eligiblitltyCheck = async () => {
        await getEligibilityForManageAddons({ graphql, setCollectionStatus, setAccountStatus });
    };

    const activeAddons = async () => {
        const addonsData = await getCurrentlyActiveAddons({
            graphql,
            sessionValue,
            setShowAddons,
            setIsLoading,
            setIsError,
            value,
        });
    };
    const addOnsToggle = () => {
        setDisplayAddOns(!displayAddOns);
        if (!displayAddOns) {
            fetchActiveAddons();
        }
    };
    const removeDuplicateAddons = arr => {
        const uniqueShowArr = new Set();
        const result = [];
        arr?.forEach(show => {
            const key = `${show.title}_${show.price}`;
            if (!uniqueShowArr[key]) {
                uniqueShowArr[key] = show;
                result.push(show);
            }
        });

        return result;
    };

    // useEffect(() => {
    //     if (showAddons?.length === 0) {
    //         activeAddons();
    //     }
    // }, []);

    useEffect(() => {
        // onPageLoad();
        eligiblitltyCheck();
    }, []);

    useEffect(() => {
        const uniqueValues = removeDuplicateAddons(showAddons);
        setUniqueShowArr(uniqueValues);
    }, [showAddons]);

    const ActiveAddonContainerReload = async () => {
        setFetchAddons(false);
        clearCacheQuery(graphql, 'getAccountStatusAndCollectionStatus');
        clearCacheQuery(graphql, 'getCurrentlySubscribedAddons');
        clearCacheQuery(graphql, 'getAddOns');
        setIsLoading(true);
        setIsError(false);
        activeAddons();
    };
    const fetchActiveAddons = async () => {
        if (fetchAddons) ActiveAddonContainerReload();
    };
    subscribe('ADDON_ADDED', ActiveAddonContainerReload);

    return (
        <>
            <Container maxWidth='lg' className={classes.MainContainer} disableGutters>
                <>
                    <Grid container className={classes.mainCard}>
                        <Grid container className={classes.addContainerHeading}>
                            <Grid
                                item
                                xs={12}
                                className={classes.mobileHeadingSpace}
                                sm
                                style={{ justifyContent: 'space-between' }}
                            >
                                <Typography className={classes.heading}>My add-ons</Typography>
                                <Typography className={classes.subHeading}>
                                    View or manage all active add-ons
                                </Typography>
                            </Grid>
                            <Grid className={classes.addonCTA}>
                                <EirButton
                                    variants='PrimaryButtonMedium'
                                    className={classes.addonPrimaryButtonMedium}
                                    style={{
                                        padding: '0.5rem 1rem',
                                        width: { xs: '100%', md: 'auto' },
                                    }}
                                    onClick={addOnsToggle}
                                >
                                    {displayAddOns ? 'Hide add-ons' : 'View add-ons'}
                                </EirButton>
                            </Grid>
                        </Grid>

                        <>
                            {displayAddOns && (
                                <Grid
                                    container
                                    alignItems='stretch'
                                    className={classes.gridWithGap}
                                    style={{
                                        display: 'flex',
                                        minHeight: isLoading ? '70px' : undefined,
                                    }}
                                >
                                    {isLoading ? (
                                        <div
                                            className='services-loader'
                                            style={{ width: '100%', justifyContent: 'center' }}
                                        >
                                            {isError ? (
                                                <div className='services-content-loading'>
                                                    Something went wrong, please try again later.
                                                </div>
                                            ) : (
                                                <Loading
                                                    className='services-loading-animation'
                                                    style={{ justifyContent: 'center' }}
                                                />
                                            )}
                                        </div>
                                    ) : uniqueShowArr.length === 0 ? (
                                        <Grid item xs={12}>
                                            <Box
                                                className={classes.addOnCard}
                                                style={{ alignSelf: 'stretch' }}
                                            >
                                                <Box className={classes.noAddonsText}>
                                                    It seems you don't have any active add-ons with
                                                    us. Keep an eye out and we'll let you know about
                                                    available add-ons for your account.
                                                </Box>
                                            </Box>
                                        </Grid>
                                    ) : (
                                        uniqueShowArr?.map((card, index) => {
                                            if (
                                                card?.code == 'AMAZON_TV' ||
                                                card?.code == 'FREE_AMAZON_TV'
                                            ) {
                                                <></>;
                                            } else {
                                                if (card?.title !== '' || card?.subtitle !== '') {
                                                    return (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={12}
                                                            md={
                                                                width >= 1020
                                                                    ? gridMdProp
                                                                    : gridMdProp1
                                                            }
                                                            key={index}

                                                            // sx={{ display: 'flex' }} // REQUIRED
                                                        >
                                                            <ActiveAddonsCard
                                                                card={card}
                                                                index={index}
                                                                setShowAddons={setShowAddons}
                                                                showAddons={uniqueShowArr}
                                                                collectionStatus={collectionStatus}
                                                                accountStatus={accountStatus}
                                                                activeAddons={activeAddons}
                                                                ActiveAddonContainerReload={
                                                                    ActiveAddonContainerReload
                                                                }
                                                            />
                                                        </Grid>
                                                    );
                                                }
                                            }
                                        })
                                    )}
                                </Grid>
                            )}
                        </>

                        <ServicesIcon icon={addOnIcon} numCards={2} />
                    </Grid>
                </>
            </Container>
        </>
    );
};

export default ActiveAddonsContainer;
